import * as $ from 'jquery'
import 'select2'

$(document).ready(function () {
    $('.js-example-basic-single').select2()
})
